module.exports = "<div class=\"preloader-choose\">\r\n    <div class=\"preloader-choose__progress\"></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./js/components/Preloader/Preloader.ejs
// module id = 231
// module chunks = 0